// extracted by mini-css-extract-plugin
export default {"content":"mimic___styles_content__6fmgk","block":"mimic___styles_block__a7UMo","sidebar":"mimic___styles_sidebar__+1LTe","sidebarContainer":"mimic___styles_sidebarContainer__2myCK"};